import { Swiper, Navigation } from 'swiper/core';
Swiper.use([Navigation]);

export default () => {
  const i = {}
  const init = () => {
    console.log('init informationSec');
    i.root = document.getElementById('information');
    if (!i.root) {
      return;
    }

    // BETTINGのカルーセル（スライダー）部分を構築
    buildSwiper();

    // RACE部分は /assets/js/data/home.js で処理
    // TWITTERはwidget埋め込み
    // PICKUP MOVIEはyoutube iframe埋め込み
  }

  const isPC = window.matchMedia('(min-width: 768px)').matches;
  const swiperOption = {
    width: calcWidthLength(isPC ? 400 : 150),
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 2,
    navigation: {
      nextEl: '.hm-info-bet__btn._next',
      prevEl: '.hm-info-bet__btn._prev'
    }
  };
  const buildSwiper = () => {
    i.container = i.root.querySelector('.hm-info-bet__container');
    const nextBtn = i.root.querySelector('.hm-info-bet__btn._next')
    const prevBtn = i.root.querySelector('.hm-info-bet__btn._prev')
    swiperOption.navigation = {
      nextEl: nextBtn,
      prevEl: prevBtn
    }
    i.swiper = new Swiper(i.container, swiperOption);
    window.addEventListener('resize', resize);
  }
  let timerId = null;
  const resize = () => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      i.swiper.destroy(true, true);
      swiperOption.width = calcWidthLength(isPC ? 400 : 150);
      i.swiper = new Swiper(i.container, swiperOption);
      timerId = null;
    }, 0);
  }

  // ブラウザ幅によってフォントサイズが異なるため、サイズ計算用の関数
  function calcWidthLength (num) {
    const ww = window.innerWidth;
    // 1rem の pixel 計算
    let ROOTREM = 0;
    if (ww > 1280) {
      ROOTREM = 10 + 2 * (ww - 1280) / 400;
    } else if (ww >= 768) {
      ROOTREM = ww * .78125 / 100;
    } else {
      ROOTREM = 10 + 8 * (ww - 375) / 649;
    }
    return (num * ROOTREM / 10) | 0;
  }


  init();
}
